import { FC, useEffect } from 'react';
import TableModule from './TableModule';
import {
  OtherCostConfig,
  OtherCostNames
} from '../ts-config';
import { Form } from 'antd';
import { isNotEmpty } from '@lhb/func';
import { fieldNameOtherCost } from './fieldname';
import { fixIntParam } from './transfer2value';

/**
 * @Description 其他类别费用成本
 */
const OtherCost: FC<{
  form: any;
  formItemData: any;
  disabled?: boolean;
  onChange: any;
}> = ({
  form,
  formItemData,
  disabled,
  onChange
}) => {
  // 水电费（第一年）
  const waterElectricityFeeFirst: any = Form.useWatch(
    fieldNameOtherCost(true, OtherCostNames.waterElectricityFee),
    form
  );
  // 水电费（第二年）
  const waterElectricityFeeSecond: any = Form.useWatch(
    fieldNameOtherCost(false, OtherCostNames.waterElectricityFee),
    form
  );

  // 日常办公费用（第一年）
  const officeExpensesFirst: any = Form.useWatch(
    fieldNameOtherCost(true, OtherCostNames.officeExpenses),
    form
  );
  // 日常办公费用（第二年）
  const officeExpensesSecond: any = Form.useWatch(
    fieldNameOtherCost(false, OtherCostNames.officeExpenses),
    form
  );

  // 宽带费（第一年）
  const internetFeeFirst: any = Form.useWatch(
    fieldNameOtherCost(true, OtherCostNames.internetFee),
    form
  );
  // 宽带费（第二年）
  const internetFeeSecond: any = Form.useWatch(
    fieldNameOtherCost(false, OtherCostNames.internetFee),
    form
  );

  // 日常宣传品费用（第一年）
  const publicityExpensesFirst: any = Form.useWatch(
    fieldNameOtherCost(true, OtherCostNames.publicityExpenses),
    form
  );
  // 日常宣传品费用（第二年）
  const publicityExpensesSecond: any = Form.useWatch(
    fieldNameOtherCost(false, OtherCostNames.publicityExpenses),
    form
  );

  // 工服费用（第一年）
  const workClothesExpensesFirst: any = Form.useWatch(
    fieldNameOtherCost(true, OtherCostNames.workClothesExpenses),
    form
  );
  // 工服费用（第二年）
  const workClothesExpensesSecond: any = Form.useWatch(
    fieldNameOtherCost(false, OtherCostNames.workClothesExpenses),
    form
  );

  // 运费及杂费（第一年）
  const incidentalExpensesFirst: any = Form.useWatch(
    fieldNameOtherCost(true, OtherCostNames.incidentalExpenses),
    form
  );
  // 运费及杂费（第二年）
  const incidentalExpensesSecond: any = Form.useWatch(
    fieldNameOtherCost(false, OtherCostNames.incidentalExpenses),
    form
  );

  // 计算其他成本
  useEffect(() => {
    const name = fieldNameOtherCost(true, OtherCostNames.otherCost);
    const val: any = calcOtherCost(waterElectricityFeeFirst, officeExpensesFirst, internetFeeFirst, publicityExpensesFirst, workClothesExpensesFirst, incidentalExpensesFirst);
    form.setFieldValue(name, val);
  }, [waterElectricityFeeFirst, officeExpensesFirst, internetFeeFirst, publicityExpensesFirst, workClothesExpensesFirst, incidentalExpensesFirst]);

  useEffect(() => {
    const name = fieldNameOtherCost(false, OtherCostNames.otherCost);
    const val: any = calcOtherCost(waterElectricityFeeSecond, officeExpensesSecond, internetFeeSecond, publicityExpensesSecond, workClothesExpensesSecond, incidentalExpensesSecond);
    form.setFieldValue(name, val);
  }, [waterElectricityFeeSecond, officeExpensesSecond, internetFeeSecond, publicityExpensesSecond, workClothesExpensesSecond, incidentalExpensesSecond]);

  /**
   * @description 其他成本
   * @param waterElectricityFee
   * @param officeExpenses
   * @param internetFee
   * @param publicityExpenses
   * @param workClothesExpenses
   * @param incidentalExpenses
   * @return
   *   水电费（年）+ 日常办公费用 + 宽带费 + 日常宣传品费用 +  工服费用 + 运费及杂费，单位：元
   */
  const calcOtherCost = (waterElectricityFee, officeExpenses, internetFee, publicityExpenses, workClothesExpenses, incidentalExpenses) => {
    let val: any = null;
    isNotEmpty(waterElectricityFee) && (val += (+waterElectricityFee));
    isNotEmpty(officeExpenses) && (val += (+officeExpenses));
    isNotEmpty(internetFee) && (val += (+internetFee));
    isNotEmpty(publicityExpenses) && (val += (+publicityExpenses));
    isNotEmpty(workClothesExpenses) && (val += (+workClothesExpenses));
    isNotEmpty(incidentalExpenses) && (val += (+incidentalExpenses));

    isNotEmpty(val) && (val = fixIntParam(val));
    return val;
  };

  return (
    <TableModule
      moduleConfig={OtherCostConfig}
      form={form}
      formItemData={formItemData}
      disabled={disabled}
      onChange={onChange}
    />
  );
};

export default OtherCost;
